module.exports = __webpack_public_path__ + "static/media/3 02 Tulleord Sgo-norming.b72401c5.mp3";